import { getValidCustomDates, isWithinDays } from "main/availability-dates";
import { getAvailabilityLabel } from "main/availability-labels";
// frontend/entrypoints/product-card.js
var product_card_default = () => ({
	optionAvailability: {},
	canScrollLeft: false,
	canScrollRight: false,
	init() {
		const optionsAttr = this.$el.dataset.options;
		if (!optionsAttr) return;
		try {
			const { options = [] } = JSON.parse(optionsAttr);
			options.forEach(({ name, availability, customVariants }) => {
				this.optionAvailability[name] = availability === "custom" ? this.validateCustomAvailability(customVariants) : availability;
			});
		} catch (e) {
			console.error("Failed to parse options data:", e);
		}
		this.$nextTick(() => this.updateScrollArrows());
		new ResizeObserver(() => this.updateScrollArrows()).observe(this.$refs.optionsScroll);
	},
	validateCustomAvailability(customVariants) {
		let hasValid = false;
		for (const v of customVariants || []) {
			const validDates = getValidCustomDates(v.dateDisponibilita, v.inventoryQty);
			if (validDates.length > 0) {
				hasValid = true;
				if (isWithinDays(validDates[0], 7)) return "custom-soon";
			} else if (v.giorniDisponibilita != null) {
				hasValid = true;
				if (v.giorniDisponibilita <= 7) return "custom-soon";
			}
		}
		return hasValid ? "custom" : "x";
	},
	updateScrollArrows() {
		const el = this.$refs.optionsScroll;
		if (!el) return;
		this.canScrollLeft = el.scrollLeft > 0;
		this.canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
	},
	scrollOptions(direction) {
		const el = this.$refs.optionsScroll;
		if (!el) return;
		el.scrollBy({
			left: direction * 100,
			behavior: "smooth"
		});
	},
	getOptionAvailability(value) {
		return this.optionAvailability[value] || "x";
	},
	getOptionAvailabilityLabel(value) {
		return getAvailabilityLabel(this.getOptionAvailability(value));
	}
});
export { product_card_default as default };
